import { createAction, props } from '@ngrx/store';

import { RestBoardModel } from '@main-application/boards/interfaces/board';

export const closeMenus = createAction('[Boards] close menus');

export const loadBoardList = createAction('[Boards] loadBoardList');
export const loadBoardListSuccess = createAction(
  '[Boards] loadBoardListSuccess',
  props<{ boards: RestBoardModel[] }>()
);
export const loadBoardListFailed = createAction('[Boards] loadBoardListFailed');
